import { useCallback } from 'react';
import { createFormTracker } from '@rs/form-tracking-sdk';
import { AnalyticStepName } from '../types/AnalyticStepName';

function useFormInteractionTracking(
  analyticsStepName: AnalyticStepName
): (form: HTMLFormElement | null) => void {
  return useCallback(
    (form: HTMLFormElement | null) => {
      if (!form) {
        return;
      }
      const formTracker = createFormTracker({ formId: 'coverage_checkup' });
      formTracker.registerFormElement(form);
      formTracker.trackStepView({ stepName: analyticsStepName });
    },
    [analyticsStepName]
  );
}

export { useFormInteractionTracking };
